import React from "react";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import AnalyticsEntryExit from "../../components/vehicle/AnalyticsEntryExit/AnalyticsEntryExit";
import Footer from "../../components/common/Footer";

export default function AnalyticsEntryExitPage() {
  const selectedApp = localStorage.getItem("selectedApp");

  return (
    <>
      <TitleBar />
      {selectedApp === "schoolTrack" ? <SchoolBusNavMenu /> : <NavMenu />}
      <AnalyticsEntryExit />
      <Footer />
    </>
  );
}
